export class SessionStorageFacade {

    /**
     * 写入会话存储
     * @param {string} key
     * @param {Object} value
     */
    static set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
        return this;
    }

    /**
     * 读取会话存储
     * @param {string} key
     * @return {Object}
     */
    static get(key) {
        try {
            let info = sessionStorage.getItem(key);
            if (info) return JSON.parse(info);
            return {};
        } catch (e) {
            return {};
        }
    }

}
